import React from 'react';

//component
import { BasicButton, CancelConfirmModal, IconLibrary, ThriveIcon } from 'thrive-components';

//hooks
import UseDisplayInformationPopUpModal from './DisplayInformationPopUpModal.hooks';



const DisplayInformationPopUpModal = () => {
    const {showModal, userCount, onShowModalClick, onCloseClick, onConfirmClick} = UseDisplayInformationPopUpModal();

    return (
        <>
            <BasicButton 
                className={"margin-left-30 link-style-button"}
                content={<span>
                    Show popup again to everyone
                    <ThriveIcon iconName={IconLibrary.REPEAT} color='#067BBE' sizeInPx='12'/>
                    </span>
                } 
                ariaLabel={'Open Modal'} 
                onButtonClick={onShowModalClick}
            />
        
            {showModal &&
                <CancelConfirmModal 
                    headerContent={"Show popup again to everyone?"} 
                    bodyContent={`${userCount} have seen and accepted this popup. Resetting will make it show again for everyone the next time they visit.`} 
                    onCloseClick={onCloseClick} 
                    cancelButtonText={"Cancel"} 
                    cancelButtonAriaLabel={"Cancel and do not reset"} 
                    confirmButtonText={'Confirm'} 
                    confirmButtonAriaLabel={'Confirm and reset the modal views'} 
                    onCancelClick={onCloseClick} 
                    onConfirmClick={onConfirmClick}        
                />          
            }
    </>
    );  
}

export default DisplayInformationPopUpModal;